/* unplugin-vue-components disabled */import script from "./MainLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./MainLayout.vue?vue&type=script&setup=true&lang=js"

import "./MainLayout.vue?vue&type=style&index=0&id=575979da&lang=css"

const __exports__ = script;

export default __exports__